module.exports = __webpack_public_path__ + "static/media/ellipse_black.10312948.svg";